<template>
    <div>
        <!-- 过滤条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="充值状态"
                clearable
                v-model="filter.rechargeStatus"
                @on-change="search"
            >
                <Option
                    v-for="item in this.dict.rechargeStatus.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="支付方式"
                clearable
                v-model="filter.payType"
                @on-change="search"
            >
                <Option
                    v-for="item in this.dict.payType.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <!-- 时间 -->
            <DatePicker
                placement="bottom-end"
                style="width: 130px; margin-left: -1px"
                v-model="startDate"
                :class="preCls + 'select-public-style'"
                transfer
                type="date"
                placeholder="开始日期"
                :options="startDateOption"
                @on-change="search"
            ></DatePicker>

            <DatePicker
                style="width: 130px; margin-left: -1px"
                v-model="endDate"
                :class="preCls + 'select-public-style'"
                transfer
                type="date"
                placeholder="结束日期"
                :options="endDateOption"
                @on-change="search"
            ></DatePicker>
            <!-- 减去多少天 -->
            <check-tag-group
                style="display: inline-block"
                v-model="fastDate"
                color="primary"
                @on-change="getEndStart"
            >
                <check-tag
                    v-for="item in fastDateList"
                    :name="item.id"
                    :key="item.id"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
        </div>

        <table-tool-bar style="margin-top: 16px">
            <template slot="left">
                <table-searcher
                    v-model="filter.nickName"
                    placeholder="请输入微信昵称或手机号"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:avatarUrl="{ row }">
                <base-img
                    height="30"
                    width="30"
                    :src="row.avatarUrl"
                ></base-img>
            </template>

            <template v-slot:status="{ row }">
                <Tag
                    type="border"
                    :color="
                        rechargeStatusList.find(
                            (item) => item.id === row.rechargeStatus
                        ).color
                    "
                    >{{
                        rechargeStatusList.find(
                            (item) => item.id === row.rechargeStatus
                        ).text
                    }}</Tag
                >
            </template>

            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    >详情</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showMRechargeForm"
            title="充值详情"
            :width="800"
            :height="500"
            :maskClosable="false"
        >
            <m-recharge-form v-if="modal.showMRechargeForm" :id="curId" />
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from "_c/grid/renderCell";
import MRechargeForm from "./m-recharge-form";
import BaseImg from "_c/base-img";

import { mInfoRechargeList } from "@/api/member";
import Dict from "_u/dict";
import { mapCache } from "@/plugins/vux-data-cache";
import dayjs from "dayjs";

const PAGE_SIZE = 20;

export default {
    name: "m-recharge-list",

    components: {
        MRechargeForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: "",
            page: {
                total: 0,
                list: [],
            },
            dict: {
                payType: Dict.NULL,
                rechargeStatus: Dict.NULL,
            },
            modal: {
                showMRechargeForm: false,
            },
            rechargeStatusList: [],
            fastDateList: [
                { id: 7, text: "近7天" },
                { id: 30, text: "近30天" },
                { id: 90, text: "近90天" },
            ],
            fastDate: [],
            // 设置开始时间不可选时间
            startDateOption: {
                disabledDate: (date) => {
                    if (this.endDate === "") {
                        return false;
                    } else if (date.getTime() > this.endDate.getTime()) {
                        return true;
                    }
                },
            },
            // 设置结束时间不可选时间
            endDateOption: {
                disabledDate: (date) => {
                    if (this.startDate === "") {
                        return false;
                    } else if (this.startDate.getTime() > date.getTime()) {
                        return true;
                    }
                },
            },
        };
    },

    computed: {
        ...mapCache({
            filter: "mRecharge",
        }),
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "rechargeNo",
                    title: "充值单号",
                    align: "left",
                    minWidth: 200,
                },
                {
                    key: "rechargeAmount",
                    title: "充值金额",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "sendAmount",
                    title: "赠送金额",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "payAmount",
                    title: "实付金额",
                    align: "right",
                    minWidth: 120,
                    render: pipeCell("currency"),
                },
                {
                    key: "payType",
                    title: "支付方式",
                    align: "center",
                    minWidth: 120,
                    render: mapCell(this.dict.payType.toList()),
                },
                {
                    key: "rechargeStatus",
                    title: "充值状态",
                    align: "center",
                    minWidth: 120,
                    slot: "status",
                },
                {
                    key: "createTime",
                    title: "充值时间",
                    align: "center",
                    minWidth: 150,
                    render: pipeCell("ymdL"),
                },
                {
                    key: "nickName",
                    title: "姓名",
                    align: "left",
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: "mobile",
                    title: "手机号",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "wxNickName",
                    title: "微信昵称",
                    align: "left",
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: "avatarUrl",
                    title: "微信头像",
                    align: "center",
                    minWidth: 100,
                    slot: "avatarUrl",
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 100,
                    slot: "action",
                    fixed: "right",
                },
            ];
        },
        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : "";
            },
            set(val) {
                this.filter.startDate = val
                    ? dayjs(val).format("YYYY-MM-DD")
                    : "";
            },
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : "";
            },
            set(val) {
                this.filter.endDate = val
                    ? dayjs(val).format("YYYY-MM-DD")
                    : "";
            },
        },
    },

    watch: {},

    created() {
        this.fetch();
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80;
        });
    },

    methods: {
        fetch() {
            this.loading = true;

            Promise.all([
                Dict.get(["pay_type", "recharge_status"]),
                mInfoRechargeList(this.filter),
            ])
                .then((args) => {
                    var [dictGroup, page] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    const list = this.dict.rechargeStatus.toList();
                    list[0].color = "#ed4014";
                    list[1].color = "#19be6b";

                    list.unshift({
                        id: "",
                        text: "全部",
                    });
                    this.rechargeStatusList = list;

                    this.setPageData(page.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },
        getEndStart(el) {
            if (el && el.length) {
                this.filter.startDate = dayjs()
                    .subtract(el[0], "day") // 减去多少天
                    .format("YYYY-MM-DD");
                this.filter.endDate = dayjs().format("YYYY-MM-DD");
                this.fetch();
            }
        },

        setPageData(data) {
            data.page.list.forEach((v) => {
                v.rechargeAmount /= 100;
                v.sendAmount /= 100;
                v.payAmount /= 100;
                if (v.rechargeStatus == "1") {
                    v.createTime = "";
                }
            });
            this.page.list = data.page.list;
            this.page.total = parseInt(data.page.totalCount);
        },
        rowClickInfo(row) {
            this.curId = row.id;
            this.modal.showMRechargeForm = true;
        },
    },
};
</script>
<style lang="less" scoped></style>
